export default "__VITE_ASSET__p0jcb9Tc__"